// Libs

// Constants
import { DOCUMENT_SERVICE, SERVICE_VERSION_1, roles, tenants } from '../configurations/settings';

// interface

export var uploadDocument = function uploadDocument(documentType, data, companyId, documentTypeId, payload) {
  var bodyFormData = new FormData();
  bodyFormData.append('data', data);
  bodyFormData.append('documentTypeId', documentTypeId);
  var headers = {
    'Authorization': 'bearer ' + payload.clientToken
  };
  if (payload.requestorPayload) {
    headers['requestor'] = payload.requestorPayload;
  }
  if (payload.role === roles.SELLER_ROLE) {
    headers['x-tenant'] = tenants.MKOS;
  } else if (payload.tenantId === tenants.MOS_IND) {
    headers['x-tenant'] = payload.tenantId;
  }
  return payload.axiosInstance.post("/".concat(DOCUMENT_SERVICE, "/").concat(SERVICE_VERSION_1, "/user/docs/").concat(companyId, "?documentType=").concat(documentType), bodyFormData, {
    headers: headers
  });
};